import { faTriangleExclamation } from '@fortawesome/duotone-light-svg-icons';
import { faBan } from '@fortawesome/pro-regular-svg-icons';
import { faExclamationCircle, faHelmetSafety } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { StepNoticeType } from '@partful/instructions-domain-models';
import { useMemo } from 'react';

export function StepNoticeIcon({ className, type }: Readonly<{ className?: string; type: StepNoticeType }>) {
  const icon = useMemo(() => {
    switch (type) {
      case StepNoticeType.Safety:
        return faHelmetSafety;
      case StepNoticeType.Warning:
        return faTriangleExclamation;
      case StepNoticeType.Danger:
        return faBan;
      default:
        return faExclamationCircle;
    }
  }, [type]);

  return (
    <div className={className}>
      <FontAwesomeIcon icon={icon} />
    </div>
  );
}
